<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3 class="pull-left">{{monthlySalesCommLan.text}}&nbsp;&nbsp;({{queryObj.REPORT_ID}})</h3>
        <div class="pull-right" style="margin-top:12px;">
          <el-button
            @click="$router.push('/sale_v2/saleMonthlyResult')"
            class="preview-btn"
            round
            type="warning"
          >{{monthlySalesCommLan.goback}}</el-button>
        </div>
        <div class="clear"></div>
      </div>
      <div class="panel" element-loading-spinner="el-icon-loading" v-loading="loading">
        <mtable
          :back="back"
          :detailExcelAjax="detailExcelAjax"
          :detailName="detailName"
          :detailTh="detailTh"
          :downLoadTran="downLoadTran"
          :jsonExcelAjax="jsonExcelAjax"
          :link="link"
          :multiLanguage="monthlySalesCommLan"
          :name="name"
          :operate="operate"
          :page="page"
          :selPage="selPage"
          :thData="thData"
          :trData="trData"
          @tableChange="tableAjax"
          v-if="trData"
        >
          <div class="filterCond" slot="handle">
            <div class="commission-condition">
              <span>{{monthlySalesCommLan.commissionType}}</span>
              <el-select @change="searchDatas" style="width: 105px;" v-model="type">
                <el-option
                  :key="val"
                  :label="key"
                  :value="val"
                  v-for="(key, val) in monthlySalesCommLan.typeList"
                ></el-option>
              </el-select>
            </div>
            <div class="commission-condition">
              <span>{{monthlySalesCommLan.status}}</span>
              <el-select @change="searchDatas" style="width: 105px;" v-model="status">
                <el-option
                  :key="val"
                  :label="key"
                  :value="val"
                  v-for="(key, val) in monthlySalesCommLan.statusList"
                ></el-option>
              </el-select>
            </div>
            <div class="commission-condition" style="line-height:0">
              <el-input class="input-with-select" v-model="selectVal">
                <el-select slot="prepend" style="width:110px" v-model="selectKey">
                  <el-option
                    :key="val"
                    :label="key"
                    :value="val"
                    v-for="(key,val) in monthlySalesCommLan.selectKeys"
                  ></el-option>
                </el-select>
                <el-button @click="searchDatas" icon="el-icon-search" slot="append"></el-button>
              </el-input>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from '../../comm/mytable'
import { getTimeDiff, updateTimeByUtc } from 'common/js/util'
import { URL_SALEMONTHLYCOMM, URL_IBMONTHLYUPDATE } from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
  name: 'saleMonCommResult',
  mixins: [
    require('common/mixin/base.js').base({
      monthlySalesCommLan: 'salesMonthlyResult'
    }),
    require('common/mixin/base.js').base({ publicLan: 'publicLan' })
  ],
  props: ['curArea'],
  data() {
    return {
      trData: [],
      queryObj: {},
      url: '',
      beginTime: '',
      endTime: '',
      timeDiff: 0,
      type: '-1',
      status: '-1',
      selectKey: 'id',
      selectVal: '',
      loading: true,
      changeTime: false,
      link: {
        key: ['AMOUNT'],
        path: 'saleMonCommDetailResult'
        //forwordKey: 'TYPE',
      },
      operate: {
        checkbox: true,
        url: api.getUrl20(this.curArea, URL_IBMONTHLYUPDATE),
        level: 'SL'
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    }
  },
  mounted() {
    this.queryObj = this.$route.query
    this.timeDiff = getTimeDiff()
    let sinStr = sessionStorage.getItem('back')
    if (sinStr) {
      let sinObj = JSON.parse(sinStr)
      let secondBack = sinObj.secondBack
      if (secondBack) {
        this.type = secondBack.type
        this.status = secondBack.status
        this.selectKey = secondBack.selectKey
        this.selectVal = secondBack.selectVal
        this.page.active = secondBack.pageNum + 1
        this.selPage.limit = secondBack.pageSize
      }
      this.tableAjax()
      delete sinObj.secondBack
      sessionStorage.setItem('back', JSON.stringify(sinObj))
    } else {
      this.tableAjax()
    }
  },
  methods: {
    searchDatas() {
      this.page.active = 1
      this.tableAjax()
    },
    tableAjax() {
      if (!/^\d{0,}$/.test(this.selectVal)) {
        this.$message.error(`${this.monthlySalesCommLan.selectKeys[this.selectKey]}${this.publicLan.notNumber}`)
        return
      }
      this.loading = true
      this.changeTime = true
      this.url = api.getUrl20(this.curArea, URL_SALEMONTHLYCOMM);
      let tableObj = {
        params: {
          type: this.type,
          status: this.status,
          [this.selectKey]: this.selectVal,
          report_id: this.queryObj.REPORT_ID,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      }
      this.$http.get(this.url, tableObj).then(res => {
        this.trData = res.data.data.data
        this.page.pageLeng = res.data.data.count
        this.setOfficeState()
        this.loading = false
      })
    },
    setOfficeState() {
      let typeList = this.monthlySalesCommLan.typeList
      let list = this.monthlySalesCommLan.statusList
      let levelObj = this.monthlySalesCommLan.levelObj
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach((item, index) => {
          item.level = levelObj[item.LEVEL]
          item.checked = false
          item.type = item.TYPE || item.TYPE == 0 ? typeList[item.TYPE] : ''
          item.status = item.STATUS || item.STATUS == 0 ? list[item.STATUS] : ''
          if (this.changeTime) item.LAST_UPDATE = updateTimeByUtc(this.timeDiff, item.LAST_UPDATE)
        })
      }
    }
  },
  computed: {
    back() {
      if (sessionStorage.getItem('back')) {
        let backObj = JSON.parse(sessionStorage.getItem('back'))
        backObj.secondBack = {
          type: this.type,
          status: this.status,
          selectKey: this.selectKey,
          selectVal: this.selectVal,
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
        return JSON.stringify(backObj)
      }
    },
    name() {
      return this.monthlySalesCommLan.text
    },
    detailName() {
      return this.monthlySalesCommLan.downloadName
    },
    downLoadTran() {
      return {
        TYPE: this.monthlySalesCommLan.typeList,
        LEVEL: this.monthlySalesCommLan.levelObj,
        STATUS: this.monthlySalesCommLan.statusList,
        CLIENT_TYPE: this.monthlySalesCommLan.client_type,
        LOW_LEVEL: this.monthlySalesCommLan.levelObj
      }
    },
    thData() {
      return this.monthlySalesCommLan.commmissionTh_v2
    },
    detailTh() {
      return this.monthlySalesCommLan.downloadTh_v2
    },
    detailExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        rID: this.queryObj.REPORT_ID,
        ajaxPar: {
          downLoadDetail: 'true',
          pageSize: this.page.pageLeng,
          pageNum: 0,
          type: this.type,
          status: this.status,
          report_id: this.queryObj.REPORT_ID,
          [this.selectKey]: this.selectVal
        }
      }
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        rID: this.queryObj.REPORT_ID,
        ajaxPar: {
          pageSize: this.page.pageLeng,
          pageNum: 0,
          type: this.type,
          status: this.status,
          report_id: this.queryObj.REPORT_ID,
          [this.selectKey]: this.selectVal
        }
      }
    }
  },
  watch: {
    monthlySalesCommLan() {
      this.changeTime = false
      this.setOfficeState()
    },
    curArea() {
      this.type = '-1'
      this.status = '-1'
      this.selectVal = ''
      this.page.active = 1
      sessionStorage.removeItem('back')
      this.operate.url = api.getUrl20(this.curArea, URL_IBMONTHLYUPDATE)
      this.tableAjax()
    }
  },
  components: {
    mtable
  }
}
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
  .preview-btn {
    border: 1px solid #f08712;
    background-color: #f08712;
    border-radius: 5px;
  }
}
.filterCond {
  float: left;
  .commission-condition {
    float: left;
    margin-right: 10px;
    .commission-search {
      float: left;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// saleMonCommResult.vue?61d0a88c